import { render } from "./detail_postage.vue?vue&type=template&id=4a2dae7f&scoped=true"
import script from "./detail_postage.vue?vue&type=script&lang=js"
export * from "./detail_postage.vue?vue&type=script&lang=js"

import "./detail_postage.vue?vue&type=style&index=0&id=4a2dae7f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a2dae7f"]])

export default __exports__